import { Document } from '@react-pdf/renderer'

import { PdfPageCounter } from '@features/exports/elements/PdfPageCounter'

import { ReportsPdfDocumentProps } from '../../hooks/useReportPdfExport'
import { ReportsPdfDocumentContextProvider } from './contexts/reportsPdfDocumentContext'
import { ReportsPdfHeader } from './elements/ReportsPdfHeader'
import { ReportsPdfPage } from './elements/ReportsPdfPage'
import { ReportsPdfTable } from './elements/ReportsPdfTable'

export const ReportsPdfDocument = (props: ReportsPdfDocumentProps) => {
  return (
    <ReportsPdfDocumentContextProvider value={{ ...props }}>
      <Document>
        <ReportsPdfPage>
          <ReportsPdfHeader />
          <ReportsPdfTable />
          <PdfPageCounter />
        </ReportsPdfPage>
      </Document>
    </ReportsPdfDocumentContextProvider>
  )
}
